<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Añadir rol</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Volver</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleSubmit">
              <base-input
                label="Nombre"
                prepend-icon="fas fa-user"
                v-model="role.name"
              />
              <validation-error :errors="apiValidationErrors.name" />
              <p v-if="validatedName" style="color: red">
                El nombre no puede estar vacío
              </p>
              <base-input
                label="Descripción"
                prepend-icon="fas fa-user"
                v-model="role.description"
              />
              <validation-error :errors="apiValidationErrors.description" />
              <p v-if="validatedDescription" style="color: red">
                La descripción no puede estar vacía
              </p>
              <div
                v-for="(permission, key, index) in permissions"
                :key="permission.id"
              >
                <card v-if="key.startsWith('api::')">
                  <div
                    v-for="(tipo, key2, index2) in permissions[key][
                      'controllers'
                    ]"
                    :key="tipo.id"
                  >
                    <p class="pb-1">
                      {{ Object.keys(permissions[key]["controllers"])[index2] }}
                    </p>
                    <div
                      v-for="(estado, key3, index3) in permissions[key][
                        'controllers'
                      ][key2]"
                      :key="estado.id"
                    >
                      <base-checkbox
                        v-model="
                          permissions[key]['controllers'][key2][key3]['enabled']
                        "
                        class="mb-3"
                      >
                        {{
                          Object.keys(permissions[key]["controllers"][key2])[
                            index3
                          ]
                        }}
                      </base-checkbox>
                    </div>
                  </div>
                </card>
              </div>

              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Añadir rol
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  layout: "DashboardLayout",

  mixins: [formMixin],

  components: {
    ValidationError,
  },

  data() {
    return {
      role: {
        type: "roles",
        name: null,
        description: null,
      },
      permissions: [],
      isValidationAllowedName: false,
      isValidationAllowedDescription: false,
    };
  },
  computed: {
    validatedName() {
      return this.isValidationAllowedName && !this.role.name;
    },
    validatedDescription() {
      return this.isValidationAllowedDescription && !this.role.description;
    },
  },
  async created() {
    await this.$store.dispatch("roles/getPermissions");
    this.permissions = this.$store.getters["roles/permissions"];
    console.log(this.permissions);
  },
  methods: {
    goBack() {
      this.$router.push({ name: "List Roles" });
    },

    async handleSubmit() {
      this.role["permissions"] = this.permissions;

      this.isValidationAllowedName = true;
      this.isValidationAllowedDescription = true;

      if (!this.validatedName && !this.validatedDescription) {
        console.log(this.role);
        try {
          await this.$store.dispatch("roles/add", this.role);

          this.$notify({
            type: "success",
            message: "Rol añadido correctamente.",
          });
          this.goBack();
        } catch (error) {
          this.$notify({
            type: "danger",
            message: "Oops, ha ocurrido un error",
          });
          this.setApiValidation(error.response.data.errors);
        }
      }
    },
  },
};
</script>
